import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Col,
  Row,
  FormGroup,
  ControlLabel,
  FormControl,
  Checkbox
} from 'react-bootstrap';
import BackLink from '../../../common/back-link/index';
import PageTitle from "../../../common/page-title/index";
import { Form, Errors, actions, Control } from 'react-redux-form';
import ArrowButton from '../../../common/button-arrow';
import {
  CreateCarousel,
  getCarousels,
  getcarousel,
  updateCarousel,
  getGroups
} from '../../../../actions/home';
import ImageUpload from '../../../common/form/elements/image-upload';
import MultiSelect from '../../../common/form/multi-select';
import ColorPicker from '../../../common/form/elements/color-picker';

class NewCarousel extends Component {
  constructor(props) {
    super(props);

    this.id = props.match.params.id;
  }

  onImageLoaded = (data) => {
    this.setState({
      ...this.state,
      image: data
    });
  };

  componentWillMount() {
    const { dispatch } = this.props;

    dispatch(getCarousels());
    dispatch(getGroups());

    if (this.isEdit()) {
      dispatch(getcarousel(this.id));
    } else {
      dispatch(actions.reset('deep.home_page_carousel'));
    }
  }

  isEdit() {
    return this.id && parseInt(this.id);
  }

  componentWillUnmount(){
    this.props.dispatch(actions.reset('deep.home_page_carousel'));
  }

  createGroupList = (groups) => {
    const grps = groups.map(curr => ({
      label: `${curr.name}`,
      value: curr.id
    }));

    return grps;
  };

  onSubmit = (payLoad) => {
    const { dispatch } = this.props;

    dispatch(
      actions.submitFields(
        'deep.home_page_carousel',
        this.isEdit() ? updateCarousel(this.id, payLoad) : CreateCarousel(payLoad)
      )
    );
  };

  render() {
    const {
    carousel,
    permissions,
    textColor,
    buttonColor,
    buttonTextColor,
    formData,
    groups
    } = this.props;
    let  image = '';

    if (formData.hasOwnProperty('link') && formData.link.hasOwnProperty('image')) {
      image = formData.link.image;
    }

    const colors = ['Red', 'Yellow', 'White', 'Grey']

    return (
      <div className="container-fluid">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/homepage#carousel"/>
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <PageTitle>{this.isEdit() ? 'Edit Slide' : 'Add Slide'}</PageTitle>
          </Col>
        </Row>

        <Form model='deep.home_page_carousel' onSubmit={this.onSubmit}>
          <Row>
            <Col md={12}>
              <Errors className="errors" model="deep.home_page_carousel"/>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <ControlLabel>Image*</ControlLabel>
              <ImageUpload
                onImageLoaded={this.onImageLoaded}
                source={image}
                sizeLimit={1024 * 1024 * 15} // 15 MB
                type={['image/png', 'image/jpg', 'image/jpeg', 'image/gif', 'video/mp4']}
                acceptsVideo={true}
                label="Upload a photo / video"
              />
            </Col>
          </Row>

          <Col md={12}>
            <FormGroup controlId="text_color">
              <ColorPicker
                model="deep.home_page_carousel.text_color"
                name="deep.home_page_carousel.text_color"
                textModel="deep.home_page_carousel.text_color"
                textName="deep.home_page_carousel.text_color"
                label="Text colour*"
                defaultColor={textColor || colors[0]}
                defaultTextColor={textColor || colors[0]}
                backgroundColorPicker={false}
                key={"deep.home_page_carousel.text_color"}
                colors={colors}
              />
            </FormGroup>

            <FormGroup controlId="title">
              <ControlLabel>Title</ControlLabel>
              <Errors
                show={{touched: true}}
                className="errors"
                model="deep.home_page_carousel.title"/>
              <Control.text model="deep.home_page_carousel.title"
                            component={FormControl}/>
            </FormGroup>

            <FormGroup controlId="text">
              <ControlLabel>Text</ControlLabel>
              <Errors
                show={{touched: true}}
                className="errors"
                model="deep.home_page_carousel.text"/>
              <Control.text model="deep.home_page_carousel.text"
                      component={FormControl}/>
            </FormGroup>

            <FormGroup controlId="button_color">
              <ColorPicker
                model="deep.home_page_carousel.button_color"
                name="deep.home_page_carousel.button_color"
                textModel="deep.home_page_carousel.button_text_color_when_hover"
                textName="deep.home_page_carousel.button_text_color_when_hover"
                label="Button colour*"
                defaultColor={buttonColor || colors[0]}
                defaultTextColor={buttonTextColor || colors[0]}
                backgroundColorPicker={true}
                key={"deep.home_page_carousel.button_color"}
                colors={colors}
              />
            </FormGroup>

            <FormGroup controlId="button_label">
              <ControlLabel>Button label</ControlLabel>
              <Errors
                show={{touched: true}}
                className="errors"
                model="deep.home_page_carousel.button_label"/>
              <Control.text model="deep.home_page_carousel.button_label"
                            component={FormControl}/>
            </FormGroup>

            <FormGroup controlId="button_link">
              <ControlLabel>Button link</ControlLabel>
              <Errors
                show={{touched: true}}
                className="errors"
                model="deep.home_page_carousel.button_link"/>
              <Control.text model="deep.home_page_carousel.button_link"
                            component={FormControl}/>
            </FormGroup>

            <h3>Slide Permissions</h3>
              <Row>
                <Col md={12}>
                  <MultiSelect
                    model='deep.home_page_carousel.group_ids'
                    data={this.createGroupList(groups) || []}
                    form={formData}
                    label="Outlet Groups"
                    value={formData.group_ids}
                    controlId="groups"
                    withAllOption
                  />
                </Col>
              </Row>
              { (!this.isEdit() && permissions) && generatePermissions(permissions) }
              { (this.isEdit() && carousel) && generatePermissionsForEdit(carousel, this.id) }
          </Col>

          <Row>
            <Col md={2} mdOffset={10}>
              <ArrowButton className="pull-right" arrow={false}>
                Save
              </ArrowButton>
            </Col>
          </Row>
        </Form>
      </div>
    )
  }
}

const generatePermissions = (permissions) => {
  if (!permissions.length) {
    return null;
  }

  return (
    permissions.map((perm, index) => {
        return (
          <FormGroup key={`perm-group-${index}`} className="permission-block">
            <b>{perm.name}</b>
            {
              perm.children.map((child, index) => {
                return (
                  <Control.checkbox key={`perm-${index}`}
                                    defaultChecked model={`deep.home_page_carousel.permission_ids[${child.id}].checked`}
                                    component={Checkbox}>
                    {child.name}
                  </Control.checkbox>
                )
              })
            }
          </FormGroup>
        )
      }
    )
  )
};

const generatePermissionsForEdit = (carousel, id) => {
  const { permissions } = carousel;

  if (!permissions.length) {
    return null;
  }

  return (
    permissions.map((perm, index) => {
        return (
          <FormGroup key={`perm-group-${index}`} className="permission-block">
            <b>{perm.name}</b>
            {
              perm.children.map((child, index) => {
                  return (
                    <Control.checkbox key={`perm-${index}`}
                                      defaultChecked={child.checked}
                                      disabled={id == 1}
                                      model={`deep.home_page_carousel.permission_ids[${child.id}].checked`}
                                      component={Checkbox}>
                      {child.name}
                    </Control.checkbox>)
              })
            }
          </FormGroup>
        )
      }
    )
  )
};

const mapStateToProps = (state) => {
  return {
    permissions: state.home.permissions,
    carousel: state.home.carousel,
    formData: state.deep.home_page_carousel,
    groups: state.groupSelector.groups || [],
    textColor: state.deep.home_page_carousel.text_color,
    buttonColor: state.deep.home_page_carousel.button_color,
    buttonTextColor: state.deep.home_page_carousel.button_text_color_when_hover
  };
};

export default connect(mapStateToProps)(NewCarousel);



// WEBPACK FOOTER //
// ./src/components/admin/homepagemenu/add-carousel/index.jsx